import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { AdminGuard } from './core/guards/admin.guard';

const routes: Routes = [
  {
    path: 'spielen',
    loadChildren: () =>
      import('./modules/game/game.module').then((m) => m.GameModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./modules/admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard, AdminGuard],
  },
  // old donation campaign links (newsletters, posts) → the Stammtisch-Abo page
  { path: 'spendenaktion', redirectTo: '/premium', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () =>
      import('./modules/shell/shell.module').then((m) => m.ShellModule),
  },
  { path: '**', redirectTo: '/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
